import { IAction } from '@Root/types'

export const PopupActionTypes = {
  CLOSE_DASHBOARD_POPUPS: '@@popup/CLOSE_DASHBOARD_POPUPS',
  CLOSE_LABEL_POPUPS: '@@popup/CLOSE_LABEL_POPUPS',
  CLOSE_VOICE_STUDIO_POPUPS: '@@popup/CLOSE_VOICE_STUDIO_POPUPS',
  OPEN_DELETE_LABEL_POPUP: '@@popup/OPEN_DELETE_LABEL_POPUP',
  OPEN_RENAME_LABEL_POPUP: '@@popup/OPEN_RENAME_LABEL_POPUP',
  OPEN_CREATE_LABEL_POPUP: '@@popup/OPEN_CREATE_LABEL_POPUP',
  OPEN_EXTERNAL_TOKEN_POPUP: '@@popup/OPEN_EXTERNAL_TOKEN_POPUP',
  OPEN_PROJECT_SHARING_POPUP: '@@popup/OPEN_PROJECT_SHARING_POPUP',
  OPEN_IMPORT_SRT_POPUP: '@@popup/OPEN_IMPORT_SRT_POPUP',
  OPEN_DELETE_PROJECT_POPUP: '@@popup/OPEN_DELETE_PROJECT_POPUP',
  OPEN_DELETE_PROJECT_VERSION_POPUP: '@@popup/OPEN_DELETE_PROJECT_VERSION_POPUP',
  OPEN_RENAME_PROJECT_POPUP: '@@popup/OPEN_RENAME_PROJECT_POPUP',
  OPEN_RENAME_PROJECT_VERSION_POPUP: '@@popup/OPEN_RENAME_VERSION_PROJECT_POPUP',
  OPEN_EXPORTATION_POPUP: '@@popup/OPEN_EXPORTATION_POPUP',
  OPEN_ACCOUNT_POPUP: '@@popup/OPEN_ACCOUNT_POPUP',
  CLOSE_ACCOUNT_POPUP: '@@popup/CLOSE_ACCOUNT_POPUP',
  OPEN_NEW_PROJECT_POPUP: '@@popup/OPEN_NEW_PROJECT_POPUP',
  OPEN_SETUP_PROJECT_POPUP: '@@popup/OPEN_SETUP_PROJECT_POPUP',
  CLOSE_SETUP_PROJECT_POPUP: '@@popup/CLOSE_SETUP_PROJECT_POPUP',
  OPEN_SETUP_PROJECT_POPUP_TTS: '@@popup/OPEN_SETUP_PROJECT_POPUP_TTS',
  CLOSE_SETUP_PROJECT_POPUP_TTS: '@@popup/CLOSE_SETUP_PROJECT_POPUP_TTS',
  OPEN_DELETE_WORKSPACE_POPUP: '@@popup/OPEN_DELETE_WORKSPACE_POPUP',
  CLOSE_DELETE_WORKSPACE_POPUP: '@@popup/CLOSE_DELETE_WORKSPACE_POPUP',
  OPEN_LABELS_MANAGER_POPUP: '@@popup/OPEN_LABELS_MANAGER_POPUP',
  CLOSE_LABELS_MANAGER_POPUP: '@@popup/CLOSE_LABELS_MANAGER_POPUP',
  OPEN_NEWSLETTER_POPUP: '@@popup/OPEN_NEWSLETTER_POPUP',
  CLOSE_NEWSLETTER_POPUP: '@@popup/CLOSE_NEWSLETTER_POPUP',
  OPEN_CREATE_WORKSPACE_POPUP: '@@popup/OPEN_CREATE_WORKSPACE_POPUP',
  CLOSE_CREATE_WORKSPACE_POPUP: '@@popup/CLOSE_CREATE_WORKSPACE_POPUP',
  OPEN_CREATE_ACCOUNT_USER_POPUP: '@@popup/OPEN_CREATE_ACCOUNT_USER_POPUP',
  CLOSE_CREATE_ACCOUNT_USER_POPUP: '@@popup/CLOSE_CREATE_ACCOUNT_USER_POPUP',
  OPEN_MANAGE_WORKSPACE_ACCESS_POPUP: '@@popup/OPEN_MANAGE_WORKSPACE_ACCESS_POPUP',
  CLOSE_MANAGE_WORKSPACE_ACCESS_POPUP: '@@popup/CLOSE_MANAGE_WORKSPACE_ACCESS_POPUP',
  OPEN_VOICE_TYPE_UPGRADE_POPUP: '@@popup/OPEN_VOICE_TYPE_UPGRADE_POPUP',
  CLOSE_VOICE_TYPE_UPGRADE_POPUP: '@@popup/CLOSE_VOICE_TYPE_UPGRADE_POPUP',
  OPEN_REMOVE_SPEAKER_VOICE_POPUP: '@@popup/OPEN_REMOVE_SPEAKER_VOICE_POPUP',
  CLOSE_REMOVE_SPEAKER_VOICE_POPUP: '@@popup/CLOSE_REMOVE_SPEAKER_VOICE_POPUP',
  OPEN_IMPORT_TERMS_POPUP: '@@popup/OPEN_IMPORT_TERMS_POPUP',
  CLOSE_IMPORT_TERMS_POPUP: '@@popup/CLOSE_IMPORT_TERMS_POPUP',
  OPEN_MOVE_TO_OTHER_WORKSPACE_POPUP: '@@popup/OPEN_MOVE_TO_OTHER_WORKSPACE_POPUP',
  CLOSE_MOVE_TO_OTHER_WORKSPACE_POPUP: '@@popup/CLOSE_MOVE_TO_OTHER_WORKSPACE_POPUP',
  OPEN_RENEW_SUBSCRIPTION_POPUP: '@@popup/OPEN_RENEW_SUBSCRIPTION_POPUP',
  CLOSE_RENEW_SUBSCRIPTION_POPUP: '@@popup/CLOSE_RENEW_SUBSCRIPTION_POPUP',
  SET_EDITING_PROJECT_IDS: '@@popup/SET_EDITING_PROJECT_IDS',
}

export interface IPopupState {
  readonly openCreateLabelPopup: boolean
  readonly openDeleteLabelPopup: boolean
  readonly openRenameLabelPopup: boolean
  readonly openImportSrtPopup: boolean
  readonly openDeleteProjectPopup: boolean
  readonly openDeleteProjectVersionPopup: boolean
  readonly openExternalTokenPopup: boolean
  readonly openProjectSharingPopup: boolean
  readonly openAccountPopup: boolean
  readonly openNewProjectPopup: boolean
  readonly openSetupProjectPopup: boolean
  readonly openSetupProjectPopupTts: boolean
  readonly openLabelsManagerPopup: boolean
  readonly openNewsletterPopup: boolean
  readonly openMoveToOtherWorkspacePopup: boolean
  readonly openDeleteWorkspacePopup: boolean
  readonly openCreateWorkspacePopup: boolean
  readonly openCreateAccountUserPopup: boolean
  readonly openManageWorkspaceAccessPopup: boolean
  readonly voiceTypeUpgradePopupLabel: string | null
  readonly openRemoveSpeakerVoicePopup: boolean
  readonly openImportTermsPopup: boolean
  readonly openRenewSubscriptionPopup: boolean
  readonly openRenameProjectPopup: boolean
  readonly openRenameProjectVersionPopup: boolean
  readonly openExportationPopup: boolean
  readonly editingSubtitleIds: number[]
  readonly editingProjectIds: string[]
  readonly editingProjectVersionIds: string[]
  readonly editingSpeakerVoiceIds: string[]
  readonly editingLabelId: number
  readonly editingLabelCaption: string
  readonly projectType?: string
  readonly editingWorkspaceIds: number[]
  readonly includePublicLink?: boolean
}

export interface IOpenExternalTokenPopupPayload {
  subtitleId: number
}

export interface IOpenProjectSharingPopupPayload {
  readonly projectIds: string[]
  readonly subtitleId?: number
  readonly includePublicLink?: boolean
}

export interface IOpenImportSrtPopupPayload {
  readonly projectVersionId: string
  readonly subtitleId: number
}

export interface IOpenDeleteProjectPopupPayload {
  readonly projectIds: string[]
}

export type IOpenExportationPopupPayload = IOpenDeleteProjectPopupPayload

export interface IOpenRenameProjectPopupPayload {
  readonly projectId: string
}

export interface IOpenDeleteProjectVersionPopupPayload {
  readonly projectVersionIds: string[]
}

export interface IOpenRenameProjectVersionPopupPayload {
  readonly projectVersionId: string
}

export interface IOpenRenameLabelPopupPayload {
  readonly labelId: number
  readonly caption: string
}

export interface IOpenDeleteLabelPopupPayload {
  readonly labelId: number
  readonly caption: string
}

export interface IOpenSetupProjectPopupPayload {
  readonly projectVersionIds: string[]
  readonly projectType?: string
}

export interface IOpenSetupProjectPopupTtsPayload {
  readonly projectVersionIds: string[]
}

export interface IOpenDeleteWorkspacePopupPayload {
  readonly workspaceIds: number[]
}

export interface IOpenRemoveSpeakerVoicePopupPayload {
  readonly speakerVoiceIds: string[]
}

export interface IOpenVoiceTypeUpgradePopupPayload {
  readonly voiceType: string
}

export interface ISetEditingProjectIdsPayload {
  readonly updatedEditingProjectIds: string[]
}

export type TPopupActionTypes =
  IAction<IOpenExternalTokenPopupPayload> |
  IAction<IOpenProjectSharingPopupPayload> |
  IAction<IOpenImportSrtPopupPayload> |
  IAction<IOpenDeleteProjectPopupPayload> |
  IAction<IOpenDeleteProjectVersionPopupPayload> |
  IAction<IOpenRenameLabelPopupPayload> |
  IAction<IOpenDeleteLabelPopupPayload> |
  IAction<IOpenSetupProjectPopupPayload> |
  IAction<IOpenSetupProjectPopupTtsPayload> |
  IAction<IOpenDeleteWorkspacePopupPayload> |
  IAction<ISetEditingProjectIdsPayload>
